import { useFeatures as e } from "@myparcel-frontend/composables";
//#region src/cookie-consent/cookie-consent.ts
var t = { cookiebot: (e, t) => {
	e.id = "Cookiebot", e.src = "https://consent.cookiebot.com/uc.js", e.setAttribute("data-cbid", t), e.setAttribute("data-blockingmode", "auto");
} };
function n(e) {
	if (process.env.NODE_ENV === "development") {
		console.warn("Cookie consent is disabled in development mode.");
		return;
	}
	if (!e.id) {
		console.error("Cookie consent ID is required.");
		return;
	}
	let n = document.createElement("script");
	n.type = "text/javascript", t[e.type](n, e.id);
	let r = document.createElement("script");
	r.type = "text/javascript", r.innerHTML = "function OptanonWrapper() { }";
	let i = document.createDocumentFragment();
	i.appendChild(n), i.appendChild(r), document.body.appendChild(i);
}
function r(e) {
	return { install: () => n(e) };
}
function i() {
	window.Cookiebot?.renew();
}
//#endregion
//#region src/features/features.ts
var a = (t) => {
	let { loadFeatures: n, isFeatureActive: r } = e();
	return { install: (e) => {
		n(t), e.config.globalProperties.$isFeatureActive = r;
	} };
};
//#endregion
export { r as createCookieConsent, a as createFeaturesPlugin, i as renewCookieConsent };
